export default __webpack_public_path__ + "static/media/Helm of the Dark Messenger.6069a1eb.jpg";